import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_register_account_modal_pcp",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": false,
  "data-bs-keyboard": false
}
const _hoisted_2 = { class: "modal-dialog mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Register PCP Account", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y m-5" }
const _hoisted_9 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Account Info </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Activation Info </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Confirmation </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Completed </h3></div></div>", 1)
const _hoisted_11 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Please fill-up all the information correctly. ")
], -1)
const _hoisted_14 = { class: "row mb-10" }
const _hoisted_15 = { class: "col-md-6 fv-row" }
const _hoisted_16 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Your First Name"
  })
], -1)
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", null, "Middle Name")
], -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Last Name", -1)
const _hoisted_29 = { class: "position-relative" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Birth Date", -1)
const _hoisted_35 = { class: "position-relative" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-10" }
const _hoisted_39 = { class: "col-md-12 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Account Access", -1)
const _hoisted_41 = { class: "row fv-row" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Password ", -1)
const _hoisted_49 = { class: "col-6" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Confirm Password ", -1)
const _hoisted_53 = {
  key: 0,
  class: "row mb-10"
}
const _hoisted_54 = { class: "col-md-12 fv-row" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Sponsor Info", -1)
const _hoisted_56 = { class: "row fv-row" }
const _hoisted_57 = { class: "col-6" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "col-6" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "col-6" }
const _hoisted_64 = /*#__PURE__*/_createVNode("option", null, "Select Position", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("option", {
  label: "Left",
  value: "L"
}, "Left", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("option", {
  label: "Right",
  value: "R"
}, "Right", -1)
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Position ", -1)
const _hoisted_70 = { "data-kt-stepper-element": "content" }
const _hoisted_71 = { class: "w-100" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Enter Activation code "),
    /*#__PURE__*/_createVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Activation code can be found in the scratch card inside your package ")
], -1)
const _hoisted_73 = { class: "row mb-10" }
const _hoisted_74 = { class: "col-md-6 fv-row" }
const _hoisted_75 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "User ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_77 = { class: "fv-plugins-message-container" }
const _hoisted_78 = { class: "fv-help-block" }
const _hoisted_79 = { class: "col-md-6 fv-row" }
const _hoisted_80 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_81 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "PIN"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_82 = { class: "fv-plugins-message-container" }
const _hoisted_83 = { class: "fv-help-block" }
const _hoisted_84 = { "data-kt-stepper-element": "content" }
const _hoisted_85 = { class: "w-100" }
const _hoisted_86 = { class: "mb-0" }
const _hoisted_87 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_88 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Please wait... verifying data... </h4><div class=\"fs-6 text-gray-600\"><a href=\"javascript:;\" class=\"fw-bolder\"></a></div></div></div>", 1)
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<div data-kt-stepper-element=\"content\"><div class=\"w-100 text-center\"><h1 class=\"fw-bolder text-dark mb-3\"></h1><div class=\"text-muted fw-bold fs-3\"> Submitting your application. Please wait </div><div class=\"text-center px-4 py-15\"><img src=\"media/illustrations/todo.png\" alt=\"\" class=\"mw-100 mh-150px\"></div></div></div>", 1)
const _hoisted_91 = { class: "d-flex flex-stack pt-15" }
const _hoisted_92 = { class: "me-2" }
const _hoisted_93 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "indicator-label" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_98 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_100 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_102 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_ConfirmRegisterPCPRetailer = _resolveComponent("ConfirmRegisterPCPRetailer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode("div", _hoisted_18, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_firstName"
                          }),
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, [
                              _createVNode(_component_ErrorMessage, { name: "insured_firstName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "insured_middleName",
                          maxlength: "50"
                        }),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "insured_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_lastName"
                          }),
                          _createVNode("div", _hoisted_30, [
                            _createVNode("div", _hoisted_31, [
                              _createVNode(_component_ErrorMessage, { name: "insured_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode("div", _hoisted_35, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_birthday",
                            format: "DD/MM/yyyy"
                          }),
                          _createVNode("div", _hoisted_36, [
                            _createVNode("div", _hoisted_37, [
                              _createVNode(_component_ErrorMessage, { name: "insured_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _createVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode("div", _hoisted_41, [
                        _createVNode("div", _hoisted_42, [
                          _createVNode(_component_Field, {
                            name: "username",
                            class: "form-control form-control-solid",
                            type: "text",
                            placeholder: "Username"
                          }),
                          _createVNode("div", _hoisted_43, [
                            _createVNode("div", _hoisted_44, [
                              _createVNode(_component_ErrorMessage, { name: "username" })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_45, [
                          _createVNode(_component_Field, {
                            name: "password",
                            class: "form-control form-control-solid",
                            type: "password",
                            placeholder: "Password"
                          }),
                          _createVNode("div", _hoisted_46, [
                            _createVNode("div", _hoisted_47, [
                              _createVNode(_component_ErrorMessage, { name: "password" })
                            ])
                          ]),
                          _hoisted_48
                        ]),
                        _createVNode("div", _hoisted_49, [
                          _createVNode(_component_Field, {
                            name: "cpassword",
                            class: "form-control form-control-solid",
                            type: "password",
                            placeholder: "Confirm Password"
                          }),
                          _createVNode("div", _hoisted_50, [
                            _createVNode("div", _hoisted_51, [
                              _createVNode(_component_ErrorMessage, { name: "cpassword" })
                            ])
                          ]),
                          _hoisted_52
                        ])
                      ])
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createBlock("div", _hoisted_53, [
                        _createVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createVNode("div", _hoisted_56, [
                            _createVNode("div", _hoisted_57, [
                              _createVNode(_component_Field, {
                                name: "sponsorid",
                                class: "form-control form-control-solid",
                                type: "text",
                                placeholder: "Sponsor ID",
                                readonly: _ctx.isDisabledUPID
                              }, null, 8, ["readonly"]),
                              _createVNode("div", _hoisted_58, [
                                _createVNode("div", _hoisted_59, [
                                  _createVNode(_component_ErrorMessage, { name: "sponsorid" })
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_60, [
                              _createVNode(_component_Field, {
                                name: "uplineid",
                                class: "form-control form-control-solid",
                                type: "text",
                                placeholder: "Upline ID"
                              }),
                              _createVNode("div", _hoisted_61, [
                                _createVNode("div", _hoisted_62, [
                                  _createVNode(_component_ErrorMessage, { name: "uplineid" })
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_63, [
                              _createVNode(_component_Field, {
                                name: "position",
                                class: "form-select form-select-lg form-select-solid",
                                as: "select",
                                disabled: _ctx.isDisabledUPID
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_64,
                                  _hoisted_65,
                                  _hoisted_66
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode("div", _hoisted_67, [
                                _createVNode("div", _hoisted_68, [
                                  _createVNode(_component_ErrorMessage, { name: "position" })
                                ])
                              ]),
                              _hoisted_69
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_70, [
                _createVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createVNode("div", _hoisted_73, [
                    _createVNode("div", _hoisted_74, [
                      _createVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "userid",
                          maxlength: "20"
                        }),
                        _createVNode("div", _hoisted_77, [
                          _createVNode("div", _hoisted_78, [
                            _createVNode(_component_ErrorMessage, { name: "userid" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_79, [
                      _createVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "securitypin",
                          maxlength: "20"
                        }),
                        _createVNode("div", _hoisted_82, [
                          _createVNode("div", _hoisted_83, [
                            _createVNode(_component_ErrorMessage, { name: "securitypin" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_84, [
                _createVNode("div", _hoisted_85, [
                  _createVNode("div", _hoisted_86, [
                    (_ctx.formData.verifyingdata)
                      ? (_openBlock(), _createBlock("div", _hoisted_87, [
                          _createVNode("span", _hoisted_88, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _hoisted_89
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.verifyingdata === false)
                      ? (_openBlock(), _createBlock(_component_ConfirmRegisterPCPRetailer, {
                          key: 1,
                          formdata: _ctx.formData,
                          userFname: _ctx.user.fname
                        }, null, 8, ["formdata", "userFname"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_90,
              _createVNode("div", _hoisted_91, [
                _createVNode("div", _hoisted_92, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createVNode("span", _hoisted_93, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                    ]),
                    _hoisted_94
                  ])
                ]),
                (_ctx.formData.verifyingdata === false && _ctx.currentStepIndex !== (_ctx.totalSteps -1))
                  ? (_openBlock(), _createBlock("div", _hoisted_95, [
                      (_ctx.currentStepIndex === _ctx.totalSteps - 2)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "submit",
                            class: "btn btn-lg btn-primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formSubmit()))
                          }, [
                            _createVNode("span", _hoisted_96, [
                              _hoisted_97,
                              _createVNode("span", _hoisted_98, [
                                _createVNode(_component_inline_svg, { src: "icons/duotone/Navigation/Right-2.svg" })
                              ])
                            ]),
                            _hoisted_99
                          ]))
                        : (_openBlock(), _createBlock("button", _hoisted_100, [
                            _hoisted_101,
                            _createVNode("span", _hoisted_102, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ], 512)
        ])
      ])
    ])
  ]))
}